var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-page",
      style: { height: _vm.window ? "100%" : "" }
    },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "filters" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "50px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("common.btn.query") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "310px" },
                      attrs: { placeholder: _vm.$t("common.tips.fuzzySearch") },
                      model: {
                        value: _vm.filter.likeName,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "likeName", $$v)
                        },
                        expression: "filter.likeName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "triggers" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.filter.pageNum = 1
                    _vm.toQuery()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "min-height": "300px" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "side-bar": _vm.sideBarDefs,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: { gridReady: _vm.onGridReady }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-pagination",
          staticStyle: { "padding-right": "0px" }
        },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }